module.exports = __webpack_public_path__ + "static/media/SG-SNI3_1ZZqFlY8qPbPgsF1al8_bmeZPD76seTrJ.222ce068.bin";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photos/SG-SNI3_1ZZqFlY8qPbPgsF1al8_bmeZPD76seTrJ
// module id = 669
// module chunks = 0